export default "GoodLock opened in June 2020.\n\nBemærk: Payment in cash or with MobilePay.";